module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnRoZW1lLWRhcmsgLmdjbC1hcmVhcy1jb3VudGVyLWl0ZW0gew0KICAgIGJvcmRlci1ib3R0b206IDFweCBzb2xpZCAkZ3JleS03MDA7DQogICAgLmdjbC1hcmVhcy1jb3VudGVyLWl0ZW0td3JhcGVyIC5nY2wtYXJlYXMtY291bnRlci1pdGVtLWhlYWQgLmdjbC1hcmVhcy1jb3VudGVyLWl0ZW0taWNvbnsNCiAgICAgICAgYm9yZGVyOiAwLjA2M3JlbSBzb2xpZCAkZ3JleS03MDA7DQogICAgfQ0KICAgIC5nY2wtYXJlYXMtY291bnRlci1pdGVtLWJvZHkgLmdjbC10aXRsZS1hcmVhc3sNCiAgICAgICAgY29sb3I6ICRncmV5LTMwMDsNCiAgICB9DQp9"


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/AreasItem/AreasItemCounterDark.scss
// module id = 2521
// module chunks = 0